import React from 'react';
import styles from '../userManagement.module.scss';

const UserManagementStats = ({ stats }) => {
  const statItems = [
    {
      title: 'Total Users',
      value: stats.totalUsers,
      className: 'total'
    },
    {
      title: 'Admin Users',
      value: stats.adminUsers,
      className: 'admin'
    },
    {
      title: 'Regular Users',
      value: stats.regularUsers,
      className: 'regular'
    },
    {
      title: 'Recently Added',
      value: stats.recentlyAdded,
      className: 'recent'
    }
  ];

  return (
    <div className={styles.statsContainer}>
      {statItems.map((stat, index) => (
        <div key={index} className={`${styles.statCard} ${styles[stat.className]}`}>
          <h3>{stat.title}</h3>
          <p className={styles.statNumber}>{stat.value || 0}</p>
        </div>
      ))}
    </div>
  );
};

export default UserManagementStats;
